<template>
  <Layout>
    <PageHeader :title="title" :items="braedcrumb" />
    <div>
      <b-row>
        <b-col>
          <b-card>
            <b-row>
              <b-col sm="12" md="3">
                <div>
                  <label>{{ $t("docnumber") }}</label>
                  <b-form-input
                    disabled
                    :placeholder="$t('docnumber')"
                    v-model="PurchaseRequisitionTotal.docnumber"
                    type="text"
                  ></b-form-input>
                </div>
              </b-col>
              <b-col sm="12" md="3">
                <div>
                  <label>{{ $t("docdate") }}</label>
                  <!-- <date-picker
                    v-model="PurchaseRequisitionTotal.docdate"
                    format="DD.MM.YYYY"
                    style="width:100%"
                    value-type="format"
                    :editable="true"
                    :placeholder="$t('docdate')"
                  ></date-picker> -->
                  <custom-date-picker
                    v-model="PurchaseRequisitionTotal.docdate"
                    format="DD.MM.YYYY"
                    type="date"
                    :clearable="true"
                    :placeholder="$t('docdate')"
                    @keyup="BindValue"
                  >
                  </custom-date-picker>
                </div>
              </b-col>
              <b-col sm="12" md="3">
                <div>
                  <label>{{ $t("finyear") }}</label>
                  <v-select
                    :options="FinYearList"
                    :reduce="(item) => item"
                    :placeholder="$t('ChooseBelow')"
                    label="name"
                    v-model="PurchaseRequisitionTotal.finyear"
                  ></v-select>
                </div>
              </b-col>
              <b-col sm="12" md="3">
                <div>
                  <label>{{ $t("settlecodelevel") }}</label>
                  <b-form-input
                    :placeholder="$t('100010')"
                    v-model="PurchaseRequisitionTotal.settlecodelevel"
                    v-mask="'######'"
                  ></b-form-input>
                </div>
              </b-col>
              <b-col sm="12" md="3">
                <div class="mt-2">
                  <label>{{ $t("functionalitemcode") }}</label>
                  <b-form-input
                    :placeholder="$t('7092-100-075')"
                    v-model="PurchaseRequisitionTotal.functionalitemcode"
                    v-mask="'####-###-###'"
                  ></b-form-input>
                </div>
              </b-col>

              <b-col sm="12" md="9">
                <div class="mt-2">
                  <label>{{ $t("detailinfo") }}</label>
                  <b-form-textarea
                    :placeholder="$t('detailinfo')"
                    v-model="PurchaseRequisitionTotal.detailinfo"
                    type="text"
                  ></b-form-textarea>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>

      <b-row>
        <b-col sm="12" md="12" lg="12">
          <b-card>
            <b-row>
              <b-col
                cols="12"
                class="text-right mb-2"
                style="text-align:end !important"
              >
                <b-button @click="FillTable" size="sm" variant="success">
                  <b-spinner v-if="FillLoading" small></b-spinner>
                  <i class="bx bx-downvote"></i>
                  {{ $t("FillTable") }}
                </b-button>
              </b-col>
            </b-row>
            <b-tabs pills>
              <b-tab :title="$t('Tables')">
                <b-table
                  :fields="fields"
                  bordered
                  responsive
                  :busy="isLoading"
                  head-row-variant="info"
                  sticky-header="60vh"
                  no-border-collapse
                  small
                  :items="PurchaseRequisitionTotal.Tables"
                  class="text-center mt-3"
                  :tbody-tr-class="rowClass"
                >
                  <template #cell(purchasesum)="{item}">
                    {{
                      $options.filters.currency(item.purchasesum, {
                        symbol: "  ",
                        fractionCount: 2,
                      })
                    }}
                  </template>
                  <template #cell(purchaseprice)="{item}">
                    {{
                      $options.filters.currency(item.purchaseprice, {
                        symbol: "  ",
                        fractionCount: 2,
                      })
                    }}
                  </template>
                  <template #cell(purchasequantity)="{item}">
                    {{
                      $options.filters.currency(item.purchasequantity, {
                        symbol: "  ",
                        fractionCount: 2,
                      })
                    }}
                  </template>
                  <template #cell(actions)="{ item }">
                    <div class="text-center">
                      <b-link>
                        <i
                          style="margin-right: 5px"
                          @click="Edit(item)"
                          class="bx bx-pencil"
                        ></i>
                      </b-link>
                      <b-link>
                        <i @click="DeleteRow(item)" class="bx bx-trash-alt"></i>
                      </b-link>
                    </div>
                  </template>
                </b-table>
              </b-tab>
              <b-tab :title="$t('MonthForOrgTables')">
                <b-table
                  :fields="fieldsOrg"
                  bordered
                  responsive
                  :busy="isLoading"
                  head-row-variant="info"
                  sticky-header="60vh"
                  no-border-collapse
                  small
                  :items="PurchaseRequisitionTotal.OrgTables"
                  class="text-center mt-3"
                  :tbody-tr-class="rowClass"
                >
                  <template #cell(purchasesum)="{item}">
                    {{
                      $options.filters.currency(item.purchasesum, {
                        symbol: "  ",
                        fractionCount: 2,
                      })
                    }}
                  </template>
                  <template #cell(purchasemonth)="{item}">
                    {{
                      $options.filters.currency(item.purchasemonth, {
                        symbol: "  ",
                        fractionCount: 2,
                      })
                    }}
                  </template>
                </b-table>
              </b-tab>
            </b-tabs>
          </b-card>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-card>
            <b-row>
              <b-col class="text-left">
                <b-button
                  @click="$router.push('/document/purchaserequisitiontotal')"
                  class="d-inline-block "
                  variant="danger"
                  ><i class="dripicons-arrow-thin-left"></i>
                  {{ $t("back") }}</b-button
                >
              </b-col>
              <b-col style="text-align: right !important; " class="text-right">
                <b-button
                  v-if="PurchaseRequisitionTotal.CanSave"
                  @click="SaveData"
                  class="d-inline-block "
                  variant="success"
                  ><i class="dripicons-checkmark"></i>
                  {{ $t("save") }}</b-button
                >
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </Layout>
</template>
<script>
import vSelect from "vue-select";
import DatePicker from "vue2-datepicker";
import Layout from "../../../router/layouts/main.vue";
import PageHeader from "@/components/page-header";
import PurchaseRequisitionTotalService from "@/services/document/purchaserequisitiontotal.service";
import HelperService from "@/services/others/helper.service";
import Multiselect from "vue-multiselect";
import CustomDatePicker from "../../../components/customDatePicker.vue"
export default {
  components: {
    Multiselect,
    Layout,
    PageHeader,
    DatePicker,
    vSelect,
    CustomDatePicker
  },
  data() {
    return {
      title: this.$t("PurchaseRequisitionTotal"),
      braedcrumb: [
        {
          text: this.$t("Document"),
        },
        {
          text: this.$t("PurchaseRequisitionTotal"),
          active: true,
        },
      ],
      items: [],
      PurchaseRequisitionTotal: {},
      isLoading: false,
      selected: {},
      filter: {
        OnDate: "",
        DepartmentID: 0,
        HREmpAppointOrderTypeID: 0,
        Search: "",
        SortColumn: "",
        OrderType: "asc",
        PageNumber: 1,
        PageLimit: 20,
        isTeacher: true,
        oblastid: 0,
        regionid: 0,
        isfarmfy: false,
      },
      fields: [
        {
          key: "id",
          label: this.$t("id"),
          tdClass: "text-right",
          sortable: true,
          thStyle: { width: "5% !important" },
        },
        {
          key: "productenktcode",
          label: this.$t("productcategory"),
          tdClass: "text-left",
          sortable: true,
          thStyle: { width: "10% !important" },
        },
        {
          key: "productname",
          label: this.$t("product"),
          tdClass: "text-left",
          sortable: true,
          thStyle: { width: "10% !important" },
        },
        {
          key: "itemofexpensecode",
          label: this.$t("itemofexpense"),
          tdClass: "text-left",
          thStyle: { width: "10% !important" },
          sortable: true,
        },
        // {
        //   key: "purchasemonth",
        //   label: this.$t("purchasemonth"),
        //   thStyle: { width: "10% !important" },
        //   sortable: true,
        // },
        {
          key: "purchasequantity",
          label: this.$t("purchasequantity"),
          tdClass: "text-right",
          variant: "info",
          sortable: true,
          thStyle: { width: "10% !important" },
        },
        {
          key: "purchaseprice",
          label: this.$t("purchaseprice"),
          tdClass: "text-right",
          thStyle: { width: "10% !important" },
          sortable: true,
        },
        {
          key: "purchasesum",
          label: this.$t("purchasesum"),
          tdClass: "text-right",
          sortable: true,
          thStyle: { width: "10% !important" },
        },
      ],
      fieldsOrg: [
        {
          key: "docnumber",
          label: this.$t("docnumber"),
          tdClass: "text-right",
          thStyle: { width: "5% !important" },
          sortable: true,
        },
        {
          key: "docdate",
          label: this.$t("docdate"),
          tdClass: "text-right",
          sortable: true,
          thStyle: { width: "5% !important" },
        },
        {
          key: "organizationname",
          label: this.$t("organization"),
          tdClass: "text-left",
          thStyle: { width: "15% !important" },
          sortable: true,
        },
        {
          key: "organizationaccountname",
          label: this.$t("organizationaccount"),
          tdClass: "text-right",
          sortable: true,
          thStyle: { width: "10% !important" },
        },
        {
          key: "purchasemonth",
          label: this.$t("purchasemonth"),
          tdClass: "text-right",
          thStyle: { width: "10% !important" },
          sortable: true,
        },
        {
          key: "purchasesum",
          label: this.$t("purchasesum"),
          tdClass: "text-right",
          sortable: true,
          thStyle: { width: "10% !important" },
        },
      ],
      data: {},
      tabrow: {
        id: 0,
        ownerid: 0,
        purchasepurpose: "",
        productcategoryid: 0,
        productcategoryname: "",
        productid: 0,
        productname: "",
        productinfo: "",
        unitofmeasureid: 0,
        unitofmeasurename: "",
        purchasequantity: 0,
        purchaseprice: 0,
        purchasesum: 0,
        purchasebase: "",
        organizationaccountid: 0,
        organizationaccountname: "",
        itemofexpenseid: 0,
        itemofexpensename: "",
        deliverytime: "",
        Status: 1,
      },
      ModalShow: false,
      FinYearList: [],
      ProductCategoryList: [],
      ProductList: [],
      UnitOfMeasureList: [],
      OrganizationAccountList: [],
      ItemOfExpenseList: [],
      editedIndex1: -1,
      editedIndex2: -1,
      number: [],
      lang: "ru",
      EduXaridPrice: [],
      UzexPrice: [],
      FillLoading: false,
      Fill: {},
    };
  },
  created() {
    for (var number = 2019; number < 2200; number++) {
      this.number.push(number);
    }
    this.lang = localStorage.getItem("locale") || "ru";
    this.show = true;
    HelperService.GetAllFinYear().then((res) => {
      this.FinYearList = res.data;
    });
    PurchaseRequisitionTotalService.Get(this.$route.params.id)
      .then((res) => {
        this.show = false;
        this.PurchaseRequisitionTotal = res.data.result;
      })
      .catch((error) => {
        this.$notification(error.response.data.error, "danger");
      });
  },
  directives: {},
  methods: {
    BindValue(value){
      this.PurchaseRequisitionTotal.docdate = value
    },
    FillTable() {
      this.FillLoading = true;
      PurchaseRequisitionTotalService.FillPurchaseRequisitionTotal(
        this.PurchaseRequisitionTotal
      )
        .then((res) => {
          this.FillLoading = false;
          this.PurchaseRequisitionTotal = res.data.result;
        })
        .catch((err) => {
          this.$notification(this.$t(err.response.data.error), "danger");
          this.FillLoading = false;
        });
    },

    calculate() {
      var self = this;
      self.tabrow.purchasesum =
        self.tabrow.purchaseprice * self.tabrow.purchasequantity;
    },
    rowClass(item, type) {
      if (item.Status === 3) return "d-none";
    },

    DeleteRow(item) {
      item.Status = 3;
    },

    check() {
      if (
        this.PurchaseRequisitionTotal.docnumber === 0 ||
        this.PurchaseRequisitionTotal.docnumber === null ||
        this.PurchaseRequisitionTotal.docnumber === undefined ||
        this.PurchaseRequisitionTotal.docnumber === ""
      ) {
        this.$notification(this.$t("docnumberNotSelected"), "danger");
        return false;
      }
      if (
        this.PurchaseRequisitionTotal.docdate === 0 ||
        this.PurchaseRequisitionTotal.docdate === null ||
        this.PurchaseRequisitionTotal.docdate === undefined ||
        this.PurchaseRequisitionTotal.docdate === ""
      ) {
        this.$notification(this.$t("docdateNotSelected"), "danger");
        return false;
      }
      if (
        this.PurchaseRequisitionTotal.finyear === 0 ||
        this.PurchaseRequisitionTotal.finyear === null ||
        this.PurchaseRequisitionTotal.finyear === undefined ||
        this.PurchaseRequisitionTotal.finyear === ""
      ) {
        this.$notification(this.$t("finyearNotSelected"), "danger");
        return false;
      }
      if (this.PurchaseRequisitionTotal.Tables.length === 0) {
        this.$notification(this.$t("TablesNotSelected"), "danger");
        return false;
      }

      return true;
    },

    SaveData() {
      if (!this.check()) {
        return false;
      }
      PurchaseRequisitionTotalService.Update(this.PurchaseRequisitionTotal)
        .then((res) => {
          this.$notification(this.$t("SuccessMessage"), "success");
          this.$router.push({ name: `purchaserequisitiontotal` });
        })
        .catch((err) => {
          this.$notification(this.$t(err.response.data.error), "danger");
        });
    },
  },
};
</script>

<style>
/* .mx-input {
  background-color: #eff2f7 !important;
} */
.text-right {
  text-align: right;
}
.text-left {
  text-align: left;
}
</style>
